import startCase from "lodash-es/startCase";

export const normalizeCategoryLabel = (raw: string): string => {
  const collapsed = raw.trim().replace(/\s+/g, " ");
  if (collapsed.length === 0) {
    return "";
  }
  return startCase(collapsed.toLowerCase());
};
